import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Testimonials.css";

class Testimonials extends Component {
  getSliderSettings = () => ({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    // enable autoplay: slide every 2 seconds
    autoplay: true,
    // increase autoplay to 3 seconds per slide
    autoplaySpeed: 3000,
    pauseOnHover: true,
  });
  renderGallery = (title, folder, files) => {


    return (
      <div className="gallery-slide">
        <div className="container text-center">
          <div className="row about-us padding-testimonial">
            <div className="col-12">
              <h2 className="display-4 gallery-title">{title}</h2>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="gallery-grid">
            {files.map((file, idx) => (
              <div className="gallery-item" key={idx}>
                <div className="logo-card">
                  <img
                    src={`/images/${folder}/${encodeURIComponent(file)}`}
                    alt={`${title} ${idx + 1}`}
                    className="gallery-img"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const settings = this.getSliderSettings();

    const investorFiles = [
      "Y_Combinator.svg",
      "Pioneer Fund.svg",
      "JAM Fund.svg",
      "Letsventure.svg",
      "Rogue Capital.svg",
      "Picture2.png",
      "Goodwater Capital.svg"
    ];

    const recognitionFiles = [
      "Bloomberg.svg",
      "Tech in Asia.svg",
      "Associated Press_.svg",
      "Times of India.svg",
      "The Economic Times.svg",
      "entrepreneur_india.svg",
      "yourstory.svg",
      "Business Standard.svg",
    ];

    return (
      <div className="InvestorsSection" id="investors-recognition">
        <div className="container text-center">
          <div className="row about-us padding-testimonial justify-content-center">
            <div className="col-12">
              <h1 className="display-4 section-heading">Our Investors and Recognition</h1>
            </div>
            <div className="col-lg-10 col-md-12 col-sm-12">
              <p className="lead para-head-space">We proudly showcase the investors who back us and the recognition we've received.</p>
            </div>
          </div>
        </div>

        <div className="container padding-2 justify-content-center">
          <div className="outer-slider-wrap">
            <Slider {...settings} className="outer-slider">
              {this.renderGallery("", "investors", investorFiles)}
              {this.renderGallery("", "recognition", recognitionFiles)}
            </Slider>
          </div>
        </div>
      </div>
    );
  }
}

export default Testimonials;
